// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80c9e374","732":"c29e0b7c","977":"8d23ad7e"}[chunkId] + ".chunk.js";
};